import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser'
import ReCAPTCHA from "react-google-recaptcha";

import { validateLogin } from './validation'
import { sendRequest } from '../Global/functions'
import { cme_kurs } from '../Global/Kurs'
import { supportInfo } from '../Global/constants';
import { mainPresentation } from '../Global/Presentation'

import InfoPopup from '../InfoPopup';
import MandatoryStar from '../MandatoryStar';
import Spinner from '../Spinner';


const debug = false;


const LoginForm = ({ jumpToStep, isDoc, newUser, setNewUser, thisUser, setThisUser, nameOfArztID, errorMessage, setErrorMessage, nameOfArztIDPlaceholder, handleCountryChange, handleEfnChange, onChange }) => {

    // -- captcha reference
    const captchaRef = useRef(null);

    // -- loading
    const [loading, setLoading] = useState(false);

    // -- on mount clear .Datenspeicherung
    useEffect(() => {
        setThisUser((prev) => ({
            ...prev,
            Datenspeicherung: 0
        }))
    }, [])


    // -- submit login
    const submitLoginForm = async (e) => {
        setLoading(true);
        try {
            e.preventDefault();

            // const form
            const form = e.target;

            // get error-message from html-dom        
            setErrorMessage("");

            // validate form
            if (validateLogin(form, setErrorMessage, isDoc, thisUser)) {

                // SEND EFN AND LASTNAME TO BACKEND
                const body = {
                    ...thisUser,
                    "VNR": cme_kurs.VNR,
                    "token": !debug ? await captchaRef.current.executeAsync() : null // generate invisible captcha to check with backend and google-api
                }
                const response = await sendRequest('POST', '/kursteilnahme/efnCheck', body);

                if (response.success) {
                    // set response-data
                    const responseCode = response.data.result;

                    // PASSED COURSE
                    if (responseCode === 3 || responseCode === 4) {
                        // on success - backend sends back Teilnehmer
                        const person = response.data.Teilnehmer[0];

                        // handling old fachgebiet entrys which are not included yet
                        if (!cme_kurs.Fachgebiete.includes(person.Fachgebiet)) person.Fachgebiet = "";

                        // set user received from database
                        setThisUser((prevState) => ({
                            ...prevState,
                            ...person
                        }));

                        // set newUser
                        if (responseCode === 3) setNewUser(false); // code 3 -> user exists
                        else if (responseCode === 4) setNewUser(true); // code 4 -> user was created

                        // go to registration form
                        jumpToStep(4);

                        // done
                        return;
                    }
                    // FAILED COURSE
                    else {
                        const supportMessage = `
                            <br>
                            <span style="color: black">
                                Sollten Sie weitere Fragen haben, wenden Sie sich bitte an unseren Support unter: 
                                ${supportInfo}
                            </span>
                        `;

                        switch (responseCode) {
                            case -2:
                                setErrorMessage(
                                    `
                                    <div>
                                        Die Kombination aus EFN und Nachnamen ist inkorrekt.
                                        ${supportMessage}
                                    </div>
                                    `
                                );
                                break;
                            case -1:
                                setErrorMessage(
                                    `<div>
                                        Sie haben diesen Kurs bereits bestanden.
                                        ${supportMessage}
                                    </div>`
                                );
                                break;
                            default:
                                setErrorMessage('');
                        }
                    }
                }
                else {
                    throw "Request fehlgeschlagen";
                }
            }


        }
        catch (e) {
            console.log("Fehler bei Login", e);
            setErrorMessage(
                `<div>
                Fehler beim Absenden Ihrer Informationen.
                <br>
                <span style="color: black">
                Bitte wenden Sie sich an unseren Support unter:
                ${supportInfo}
                </span>
                </div>`
            );
        }
        // reset catpcha-ref
        captchaRef.current.reset();
        // finished loading
        setLoading(false);
    }


    return (
        <form id="login-form" className="loginHandler-form" onSubmit={submitLoginForm}>

            {/* teilnehmer-form */}
            <div className="form-input-container">

                {/* country */}
                <div>
                    <InfoPopup text={`Bitte wählen Sie zunächst ein Land aus um Ihre ${nameOfArztID} einzugeben`} />

                    <label htmlFor="countryInputLogin">Land<sup className="mandatory-field">*</sup></label>
                    <select name="countryInputLogin" id="countryInputLogin" form="login-form" className="form-dropdown-input" value={thisUser.Land ? thisUser.Land : ""} onChange={handleCountryChange} autoComplete='section-login country-name'>
                        <option value="" disabled hidden>Bitte wählen</option>
                        <option value="Deutschland">Deutschland</option>
                        <option value="Österreich">Österreich</option>
                        <option value="Andere">Andere</option>
                    </select><br />
                </div>

                {/* users efn */}
                <div countryset={(thisUser.Land) ? "true" : "false"}>
                    <label>{nameOfArztID}<sup className="mandatory-field">*</sup></label>
                    <input
                        name="efnInput"
                        type="text"
                        placeholder={nameOfArztIDPlaceholder}
                        value={thisUser.EFN ? thisUser.EFN : ""}
                        onChange={handleEfnChange}

                        // efn is read only if user is no doctor and is new -> gets a efn asigned
                        readOnly={(!isDoc && newUser) ? true : false}

                        autoComplete='section-login efn'
                    /><br />
                </div>

                {/* Hinweis für Nicht-Ärze bei GCP Kursen -> "Fortbildungsnummer notieren!" */}
                {(cme_kurs.isGcp && thisUser.Land && !isDoc && newUser) ?
                    <span><br />
                        <p>
                            <span style={{ color: "red", fontWeight: "bold" }}>Bitte kopieren Sie sich die angegebene Fortbildungsnummer</span><br />
                            <span style={{ color: "gray", fontSize: "0.8rem" }}>
                                Diese wird für alle weiteren Module benötigt!<br />
                                Ansonsten kann kein Zertifikat für den gesamten Kurs erstellt werden.
                                Diese Fortbildungsnummer finden Sie auch auf Ihrer 1. Teilnahmebescheinigung unten rechts.
                            </span>
                        </p><br />
                    </span>
                    : <></>}


                {/* users last name */}
                <div>
                    <label>Nachname<sup className="mandatory-field">*, **</sup></label>
                    <input name="nameInput" type="text" placeholder="Ihr Nachname" value={thisUser.Nachname ? thisUser.Nachname : ""} onChange={(e) => onChange(e, "Nachname")} autoComplete='section-login family-name' /><br />
                </div>
                <div style={{ color: "gray", fontSize: "0.7rem" }}><sup className="mandatory-field">**</sup>Nur Nachname. Ohne akademische Grade.</div>

                {/* mandatory agreement */}
                <div className="forCheckbox">
                    <input id="datenschutzAgreementInput" name="datenschutzAgreementInput" type="checkbox" value={thisUser.Datenspeicherung ? thisUser.Datenspeicherung : ""} checked={thisUser.Datenspeicherung ? true : false} onChange={(e) => onChange(e, "Datenspeicherung")} />
                    <label htmlFor="datenschutzAgreementInput">
                        Hiermit stimme ich der Verarbeitung meiner personenbezogenen Daten (<a href="#" onClick={() => mainPresentation.goToDatenschutz()}><u>siehe Datenschutzerklärung</u></a>) zum Zwecke der Zertifikatserstellung und -übermittlung zu.
                        Den Widerruf meiner Einwilligung und die Löschung meiner personenbezogenen Daten kann ich über <a href="mailto:cmekurs@cmeducation.de"><u>cmekurs@cmeducation.de</u></a> jederzeit veranlassen.<sup className="mandatory-field">*</sup><br />
                    </label>
                    <br />
                </div>


                {/* not a robot */}
                <ReCAPTCHA
                    sitekey={process.env.REACT_APP_SITE_KEY}
                    ref={captchaRef}
                    size="invisible"
                />


                {/* red star explanation */}
                <MandatoryStar />


                {/* error messages gonne be displayed here */}
                <div className="error-message">{parse(errorMessage)}</div>

                {/* login-button */}
                {!loading ?
                    <input
                        id="submit-login-btn"
                        className={`my-btn ${(!thisUser.Land || !thisUser.EFN || !thisUser.Nachname || !thisUser.Datenspeicherung) ? "inactive" : ""}`}
                        type="submit"
                        value="Login"
                    />
                    :
                    <Spinner />
                }

            </div>

        </form>
    )
}

export default LoginForm